import React from 'react'
import { Link } from 'react-router-dom'
import { Image } from '@deal/components'
import {
  SellableCardFragment,
  ConsumerSellableReactionRating,
  ConsumerReactionsForSellableComponent
} from '#src/generated/graphql'
import SellableReactions from '#src/components/SellableReactions'
import { getSellableUrl, formatSellablePricing } from '#src/services/sellable'
import styles from './styles.css'

interface FeaturedSellableProps {
  sellable?: SellableCardFragment
  onSellableRatingSelected: (sellableRating: ConsumerSellableReactionRating) => void
}

const FeaturedSellable: React.SFC<FeaturedSellableProps> = ({
  sellable,
  onSellableRatingSelected
}) => {
  if (!sellable || sellable.images.length === 0 || !sellable.department) {
    return null
  }

  const formattedPricing = formatSellablePricing(sellable)

  return (
    <div className={styles.sellable}>
      <div className={styles.image}>
        <Link to={getSellableUrl(sellable)}>
          <Image src={sellable.images[0].url} width={350} className={styles.sellableImage} />
        </Link>
      </div>
      <div className={styles.details}>
        {sellable.brand && <div className={styles.brand}>{sellable.brand.displayName}</div>}
        <div className={styles.title}>
          <Link to={getSellableUrl(sellable)} className={styles.titleLink}>
            {sellable.title}
          </Link>
        </div>
        {formattedPricing && <div className={styles.price}>{formattedPricing.price}</div>}
      </div>
      <div className={styles.reactions}>
        <ConsumerReactionsForSellableComponent
          variables={{
            id: sellable.id
          }}
        >
          {({ data, loading }) => {
            if (data && data.sellable) {
              const consumerSellableReaction =
                data.sellable.consumerSellableReactions &&
                data.sellable.consumerSellableReactions.edges[0] &&
                data.sellable.consumerSellableReactions.edges[0].node &&
                data.sellable.consumerSellableReactions.edges[0].node.ratingWithDisplayName

              return (
                <SellableReactions
                  selectedRating={consumerSellableReaction}
                  onSellableRatingSelected={onSellableRatingSelected}
                />
              )
            } else {
              return (
                <SellableReactions
                  isDisabled={loading}
                  onSellableRatingSelected={onSellableRatingSelected}
                />
              )
            }
          }}
        </ConsumerReactionsForSellableComponent>
      </div>
    </div>
  )
}

export default FeaturedSellable
